<template>
  <form
    class="db-filters-form"
    novalidate
  >
    <div
      v-if="true"
      class="db-modal-form-content"
    >
      <fieldset
        v-for="(filterGroup, index) in filters"
        :key="index"
        class="db-filters-fieldset"
      >
        <!-- Double "tilte" for accessibily and styling purpose -->
        <legend class="db-visually-hidden">
          {{ filterGroup.label }}
        </legend>
        <p
          class="db-filters-fieldset-legend db-title-5 db-uppercase"
          aria-hidden="true"
        >
          {{ filterGroup.label }}
        </p>
        <button
          type="button"
          class="db-filters-fieldset-reset db-button-text-link db-bold"
          v-on:click.prevent="clearFilterGroup(filterGroup)"
        >
          {{ $t('Clear') }} <span class="db-visually-hidden">{{ filterGroup.label }}</span>
        </button>
        <DbCheckbox
          v-for="option in filterGroup.options"
          :key="option.value"
          :modelValue="formData[filterGroup.key] || []"
          :inputAttrs="{
            value: option.value,
            name: filterGroup.key,
            disabled:
              filterGroup.type == 'range' &&
              formData[filterGroup.key] &&
              formData[filterGroup.key] != '',
          }"
          v-on:update:model-value="($event) => updateOption($event, filterGroup)"
        >
          {{ option.label }}
          <span
            v-if="option.getCount"
            class="db-filter-facets"
          >
            {{ option.getCount() != '' ? '(' + option.getCount() + ')' : '' }}
          </span>
        </DbCheckbox>
      </fieldset>
    </div>

    <div class="db-modal-form-footer">
      <button
        type="button"
        class="db-button-tertiary db-button-large"
        v-on:click.prevent="resetData"
      >
        {{ $t('Reset all') }}
      </button>
      <button
        type="button"
        class="db-button-primary db-button-large"
        v-on:click.prevent="$emit('done')"
      >
        {{ $t('Done') }}
      </button>
    </div>
  </form>
</template>

<script setup lang="ts">
import type { FilterGroup } from './SearchWrapperTypes'
import type { Option, Filters, SelectedData } from './SearchWrapperTypes'
import { ref, watch, watchEffect } from 'vue'
import type { CheckboxAttrs } from '@/types/components/forms'

const props = defineProps<{
  modelValue: SelectedData
  filters: Filters
}>()

const emit = defineEmits<{
  (e: 'reset-option'): void
  (e: 'done'): void
  (e: 'update:modelValue', selectedData: SelectedData): void
}>()

/**
 * Stores the current state of the form
 */
const formData = ref<SelectedData>({})

watchEffect(() => {
  formData.value = props.modelValue
})

/** After checking / unchecking, we updated our internal state */
const updateOption = (selectedOptions: CheckboxAttrs['checked'], filterGroup: FilterGroup) => {
  formData.value[filterGroup.key] = selectedOptions as Option['value'][]
}

const resetData = () => {
  formData.value = {}
}

// This is a "on change" form
// in case you whish to change to a "on validate form",
// just update this watch
watch(
  formData,
  () => {
    emit('update:modelValue', formData.value)
  },
  { deep: true },
)

const clearFilterGroup = (filterGroup: FilterGroup) => {
  formData.value[filterGroup.key] = []
}
</script>

<style>
@import '@/assets/styles/components/template-parts/_funnel-filters-form.css';
/* Filter modal styles */
@import '@/assets/styles/components/modals/_modal-filters.css';
</style>
